import { ChangeDetectionStrategy, Component, booleanAttribute, computed, input, output } from '@angular/core';
import { ZagButton, type ButtonSize, type ButtonStyle, type ButtonType } from '../button/button';
import { ZagIcon } from '../icon/icon';

@Component({
  selector: 'zag-split-button',
  imports: [ZagButton, ZagIcon],
  templateUrl: './split-button.component.html',
  styleUrl: './split-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'zag-split-button-host',
  },
})
export class SplitButtonComponent {
  readonly primaryLabel = input.required<string>();
  readonly primaryIcon = input<string | null>(null);
  readonly primaryAriaLabel = input<string | null>(null);

  readonly secondaryIcon = input('settings');
  readonly secondaryAriaLabel = input<string>('Open split button options');

  readonly zagButton = input<ButtonStyle | ''>('');
  readonly zagType = input<ButtonType>('secondary');
  readonly zagSize = input<ButtonSize>('md');

  readonly disabled = input(false, { transform: booleanAttribute });
  readonly zagLoading = input(false, { transform: booleanAttribute });

  readonly primaryClicked = output<void>();
  readonly secondaryClicked = output<void>();

  readonly isDisabled = computed(() => this.disabled() || this.zagLoading());

  onPrimaryClick(): void {
    if (this.isDisabled()) return;
    this.primaryClicked.emit();
  }

  onSecondaryClick(): void {
    if (this.isDisabled()) return;
    this.secondaryClicked.emit();
  }
}
